import { RootState } from '../../../../store/configureStore';
import { State as CaseState } from '../cases/types';
import { TSubPage, TSubPages } from './types';

export const getIsCaseDirty = (state: RootState) => {
  const reduxCase = state.currentCase as NonNullable<CaseState>;
  const subPagesDirty = Object.keys(reduxCase.subPages).map((subPage) => {
    const item = reduxCase.subPages[subPage as keyof TSubPages];
    if (Array.isArray(item)) {
      const applicantsDirty = (item as TSubPages['APPLICANTS']).map((applicant) => {
        const applicantDirty = Object.keys(applicant).map((applicantSubPage) => {
          return applicant[applicantSubPage as keyof TSubPages['APPLICANTS'][0]].isDirty;
        });

        return applicantDirty.some((val) => val);
      });
      return applicantsDirty.some((val) => val);
    }

    return (item as TSubPage).isDirty;
  });

  return subPagesDirty.some((val) => val);
};

export const getIsCaseSubPageDirty = (state: RootState, subPage: keyof TSubPages) => {
  const reduxCase = state.currentCase as NonNullable<CaseState>;
  const foundSubPage = reduxCase.subPages[subPage] as TSubPage;
  return foundSubPage && foundSubPage.isDirty;
};
